import { SkeletonProductCard } from "@/src/components/cards/components/SkeletonProductCard";

type Props = { number: number };

const LoadingSkeletonCards: React.FC<Props> = ({ number }) => (
  <>
    {Array.from({ length: number }).map((v, n) => (
      <SkeletonProductCard key={n} delayMs={n * 100} />
    ))}
  </>
);

export default LoadingSkeletonCards;
